/** Motion tokens — durations (ms) from the design's keyframes/transitions. */
export const Motion = {
  fast: 100, // button press / hover color
  base: 150, // card hover lift
  slideup: 200, // modal entrance
  slidein: 180, // toast entrance
  fade: 180, // overlay scrim
  toggle: 180, // toggle knob
} as const;
